import React from "react";
import "./EventActivityPricing.scss";

const EventActivityPricing = ({ price, currency = "₹" }) => {
  const handleCheckout = () => {
    // Handle checkout logic
    console.log("Checkout clicked");
  };

  return (
    <div className="event-activity-pricing">
      <div className="event-activity-pricing__price">
        <span className="currency">{currency}</span>
        <span className="amount">{price}</span>
      </div>
      <p className="event-activity-pricing__note">
        to pay before your live date
      </p>
      <button className="btn btn-checkout" onClick={handleCheckout}>
        Register
      </button>
    </div>
  );
};

export default EventActivityPricing;
